import { Box, Button, LinearProgress, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { FIRST_NAME, LAST_NAME } from "src/constants/searchParams";
import { useGetProviderAvailabilitiesQuery } from "src/api/services/availabilityApi";
import { useFromAndTo } from "src/hooks/useFromAndTo";
import { useColumns } from "./useColumns";
import DataTable from "src/components/DataTable";
import { usePagination } from "src/hooks/usePagination";
import AddIcon from "@mui/icons-material/Add";
import CreateAvailabilityModal from "src/components/Modals/CreateAvailabilityModal";
import { useManageModal } from "src/hooks/useManageModal";

const ProvidersAvailability = () => {
  const [params] = useSearchParams();
  const { from, to } = useFromAndTo();
  const columns = useColumns();
  const pagination = usePagination();
  const [createOpen, { handleOpen: openCreate, handleClose: closeCreate }] =
    useManageModal();

  const queryParams = useMemo(() => {
    return {
      first_name: params.get(FIRST_NAME) ?? undefined,
      last_name: params.get(LAST_NAME) ?? undefined,
      from,
      to,
    };
  }, [from, params, to]);

  const height = useMemo(() => window.innerHeight - 104 - 64 - 34, []);

  const { data, isFetching } = useGetProviderAvailabilitiesQuery(queryParams);

  const { providers, count } = useMemo(() => {
    if (data == null) {
      return { providers: [], count: 0 };
    }

    return { providers: data.data, count: data.count };
  }, [data]);

  return (
    <Stack gap="32px">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center``"
      >
        <Typography variant="h4" fontWeight={600}>
          Provider Availability
        </Typography>
        <Button startIcon={<AddIcon />} onClick={openCreate}>
          Add Availability
        </Button>
      </Stack>
      {/* <Stack
        direction="row"
        gap="16px"
        height={60}
        width="100%"
        alignItems="center"
      >
        {filters.map((filter) => (
          <Filter key={filter.name} current={filter} />
        ))}
      </Stack> */}
      <Stack gap={0}>
        <Box height={4}>
          {isFetching ? <LinearProgress color="secondary" /> : null}
        </Box>
        <DataTable
          columns={columns}
          data={providers}
          total={count}
          primaryKey="id"
          height={height}
          pagination={pagination}
        />
      </Stack>
      <CreateAvailabilityModal open={createOpen} onClose={closeCreate} />
    </Stack>
  );
};

export default ProvidersAvailability;
